import React, { useState } from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'

import ResellerProfileForm from '_forms/resellerProfileForm'
import useCanAdminLicenses from '../../../hooks/useCanAdminLicenses'

const ResellerProfile = (props) => {

  const canAdmin = useCanAdminLicenses();
  const [state, setState] = useState({
    profile: R.prop('profile', props),
    dirty: false
  });

  const onChange = (e, data) => setState({
    profile: R.merge(state.profile, {[data.name]: data.value}),
    dirty: true
  })

  const onCancel = (e) => {
    e.preventDefault();
    setState({ profile: props.profile, dirty: false });
  };

  const onSubmit = (e, data) => {
    e.preventDefault();
    props.onProfileSubmit(state.profile);
    setState({ profile: state.profile, dirty: false });
  }
  return (
    <ResellerProfileForm
      profile={state.profile}
      dirty={state.dirty}
      onSubmit={onSubmit}
      onChange={onChange}
      onCancel={onCancel}
      readOnly={ !canAdmin }
    />
  );
}

ResellerProfile.propTypes = {
  onProfileSubmit: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired
}

export default ResellerProfile



// WEBPACK FOOTER //
// ./webAdmin/components/resellers/reseller/profile.js